import { render, staticRenderFns } from "./documento.vue?vue&type=template&id=7bbac6b9&scoped=true"
import script from "./documento.vue?vue&type=script&lang=js"
export * from "./documento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbac6b9",
  null
  
)

export default component.exports